import React from 'react';
import c from 'classnames';
import s from './InputSuccessMessage.scss';
/**
 * A success message! Meant to follow an input field.
 */
var InputSuccessMessage = function (_a) {
    var children = _a.children, className = _a.className;
    return React.createElement("span", { className: c(s['root'], className) }, children);
};
InputSuccessMessage.displayName = 'InputSuccessMessage';
export default InputSuccessMessage;
//# sourceMappingURL=InputSuccessMessage.js.map